export default __webpack_public_path__ + "static/media/linux.44543b9f.svg";